import {useEffect, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import type {Dispatch} from "redux";

import {IRPStore} from "../../app/rp_reducer";
import {ISelectedRegion} from "../../offer/list/actions/offer_list_selected_data_actions";
import {ISmartAdActions, removeSmartAdOffers} from "../actions/add_smart_offer_action";
import {ISmartAdServer} from "../types/IsmartAdServer";

declare global {
    interface Window {
        sas?: ISmartAdServer;
    }
}

export function useRegionAdServerRefresh() {
    const dispatch: Dispatch<ISmartAdActions> = useDispatch();
    const lastTarget = useRef("");
    const selectedRegions = useSelector((store: IRPStore) => store.offerList.selectedRegions);

    const getSingleRegionAdTarget = (singleRegion: ISelectedRegion) => {
        const regionId = singleRegion.id;
        const city = singleRegion?.stats?.region_type_city;
        const voivodeshipSlug = singleRegion?.stats?.region_type_voivodeship?.slug;

        return `region=${voivodeshipSlug};region_id=${regionId};region_parent_city=${city?.slug}`;
    };

    useEffect(() => {
        dispatch<ISmartAdActions>(removeSmartAdOffers());
    }, [selectedRegions]);

    return () => {
        const isSingleRegion = selectedRegions.length === 1;
        //  Ads shouldn't be available for multiple regions
        const adTarget = isSingleRegion ? getSingleRegionAdTarget(selectedRegions[0]) : "region=unknown;region_id=unknown;region_parent_city=unknown";

        if (adTarget !== lastTarget.current) {
            lastTarget.current = adTarget;

            if (isSingleRegion) {
                window.sas?.cmd.push(function () {
                    window.sas?.refresh({target: adTarget});
                });
            }
        }
    };
}
import {useEffect, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import type {Dispatch} from "redux";

import {IRPStore} from "../../app/rp_reducer";
import {ISelectedRegion} from "../../offer/list/actions/offer_list_selected_data_actions";
import {ISmartAdActions, removeSmartAdOffers} from "../actions/add_smart_offer_action";
import {ISmartAdServer} from "../types/IsmartAdServer";

declare global {
    interface Window {
        sas?: ISmartAdServer;
    }
}

export function useRegionAdServerRefresh() {
    const dispatch: Dispatch<ISmartAdActions> = useDispatch();
    const lastTarget = useRef("");
    const selectedRegions = useSelector((store: IRPStore) => store.offerList.selectedRegions);

    const getSingleRegionAdTarget = (singleRegion: ISelectedRegion) => {
        const regionId = singleRegion.id;
        const city = singleRegion?.stats?.region_type_city;
        const voivodeshipSlug = singleRegion?.stats?.region_type_voivodeship?.slug;

        return `region=${voivodeshipSlug};region_id=${regionId};region_parent_city=${city?.slug}`;
    };

    useEffect(() => {
        dispatch<ISmartAdActions>(removeSmartAdOffers());
    }, [selectedRegions]);

    return () => {
        const isSingleRegion = selectedRegions.length === 1;
        //  Ads shouldn't be available for multiple regions
        const adTarget = isSingleRegion ? getSingleRegionAdTarget(selectedRegions[0]) : "region=unknown;region_id=unknown;region_parent_city=unknown";

        if (adTarget !== lastTarget.current) {
            lastTarget.current = adTarget;

            if (isSingleRegion) {
                window.sas?.cmd.push(function () {
                    window.sas?.refresh({target: adTarget});
                });
            }
        }
    };
}
